export enum ResponseMessage {
  TokenExpired = "Token expired",
  InvalidToken = "Invalid Token",
  JWTExpired = "jwt expired",
  NoAuthToken = "No auth token",
}
